import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the reportAdmin state domain
 */

const selectReportAdminDomain = (state) =>
  state.get("reportAdmin", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoading = () =>
  createSelector(selectReportAdminDomain, (state) => state.get("isLoading"))

export const makeSelectIsMeasureProcess = () =>
  createSelector(selectReportAdminDomain, (state) =>
    state.get("isMeasureProcess")
  )

export const makeSelectDimensionsBottom = () =>
  createSelector(selectReportAdminDomain, (state) =>
    state.get("dimensionsBottom")
  )

export const makeSelectDimensionsTop = () =>
  createSelector(selectReportAdminDomain, (state) => state.get("dimensionsTop"))

export const makeSelectDivisionsAvailable = () =>
  createSelector(selectReportAdminDomain, (state) =>
    state.get("divisionsAvailable")
  )

export const makeSelectDivisionsData = () =>
    createSelector(selectReportAdminDomain, (state) =>
      state.get("divisionsData")
    )

export const makeSelectMeasureGeneral = () =>
  createSelector(selectReportAdminDomain, (state) =>
    state.get("measureGeneral")
  )

export const makeSelectMeasureTotal = () =>
  createSelector(selectReportAdminDomain, (state) => state.get("measureTotal"))

export const makeSelectMeasureConfig = () =>
  createSelector(selectReportAdminDomain, (state) => state.get("measureConfig"))

export const makeSelectIsSectorDataAvailable = () =>
  createSelector(selectReportAdminDomain, (state) =>
    state.get("isSectorDataAvailable")
  )

export const makeSelectCompanySectors = () =>
  createSelector(selectReportAdminDomain, (state) =>
    state.get("companySectors")
  )
  export const makeSelectCompanySectorsGlobal = () =>
    createSelector(selectReportAdminDomain, (state) =>
      state.get("companySectorsGlobal")
    )
export const makeSelectCompanySector = () =>
  createSelector(selectReportAdminDomain, (state) =>
    state.get("companySector")
  )

export const makeSelectIsErrorStatus = () =>
  createSelector(selectReportAdminDomain, (state) => state.get("isErrorStatus"))

export const makeSelectMeasureColorRange = () =>
  createSelector(selectReportAdminDomain, (state) =>
    state.get("measureColorRange")
  )

export const makeSelectIsLoadingTotal = () =>
  createSelector(selectReportAdminDomain, (state) =>
    state.get("isLoadingTotal")
  )

export const makeSelectIsLoadingSaveConfig = () =>
  createSelector(selectReportAdminDomain, (state) =>
    state.get("isLoadingSaveConfig")
  )

export const makeSelectUserType = () =>
  createSelector(selectReportAdminDomain, (state) => state.get("userType"))

const makeSelectReportAdmin = () =>
  createSelector(selectReportAdminDomain, (substate) => substate.toJS())

export default makeSelectReportAdmin
export { selectReportAdminDomain }
